module.exports = __webpack_public_path__ + "img/step57_a_switch_on_the_printer.bcc5c5d5.png";